import React, { useState } from 'react';
import { Box, Button, Grid, TextField, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, IconButton, MenuItem, Select, InputLabel, FormControl } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

export const TableCRUD = () => {
    const [tables, setTables] = useState([]);
    const [tableDetails, setTableDetails] = useState({
        id: '',
        numberOfSheets: '',
        availability: 'Yes'
    });
    const [editIndex, setEditIndex] = useState(-1);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setTableDetails({ ...tableDetails, [name]: value });
    };

    const handleAddTable = () => {
        if (editIndex >= 0) {
            const updatedTables = [...tables];
            updatedTables[editIndex] = tableDetails;
            setTables(updatedTables);
            setEditIndex(-1);
        } else {
            setTables([...tables, tableDetails]);
        }
        setTableDetails({
            id: '',
            numberOfSheets: '',
            availability: 'Yes'
        });
    };

    const handleEdit = (index) => {
        setTableDetails(tables[index]);
        setEditIndex(index);
    };

    const handleDelete = (index) => {
        setTables(tables.filter((_, i) => i !== index));
    };

    return (
        <Box sx={{ p: 3 }}>
            <Typography variant="h4" gutterBottom>
                Table Management
            </Typography>

            <Grid container spacing={2}>
                <Grid item xs={12} md={4}>
                    <TextField
                        fullWidth
                        label="ID"
                        name="id"
                        value={tableDetails.id}
                        onChange={handleChange}
                        type="text"
                        required
                    />
                </Grid>
                <Grid item xs={12} md={4}>
                    <TextField
                        fullWidth
                        label="Number of Sheets"
                        name="numberOfSheets"
                        value={tableDetails.numberOfSheets}
                        onChange={handleChange}
                        type="number"
                        required
                    />
                </Grid>
                <Grid item xs={12} md={4}>
                    <FormControl fullWidth>
                        <InputLabel>Availability</InputLabel>
                        <Select
                            name="availability"
                            value={tableDetails.availability}
                            onChange={handleChange}
                            label="Availability"
                        >
                            <MenuItem value="Yes">Yes</MenuItem>
                            <MenuItem value="No">No</MenuItem>
                        </Select>
                    </FormControl>
                </Grid>

                <Grid item xs={12}>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleAddTable}
                        sx={{ mt: 2, display: 'block', margin: '0 auto', backgroundColor: 'orange' }}
                    >
                        {editIndex >= 0 ? 'Save Table' : 'Add Table'}
                    </Button>
                </Grid>
            </Grid>

            <TableContainer component={Paper} sx={{ mt: 4 }}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>ID</TableCell>
                            <TableCell>Number of Sheets</TableCell>
                            <TableCell>Availability</TableCell>
                            <TableCell>Actions</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {tables.map((table, index) => (
                            <TableRow key={index}>
                                <TableCell>{table.id}</TableCell>
                                <TableCell>{table.numberOfSheets}</TableCell>
                                <TableCell>{table.availability}</TableCell>
                                <TableCell>
                                    <IconButton onClick={() => handleEdit(index)}>
                                        <EditIcon />
                                    </IconButton>
                                    <IconButton onClick={() => handleDelete(index)} color="error">
                                        <DeleteIcon />
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );
};

export default TableCRUD;
